import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { slugify } from '../../utils/constants';

const GameCard = ({ name, banner, slug, badge }) => {
  const [loaded, setLoaded] = useState(false);
  const href = `/game/${slug || slugify(name)}`;

  return (
    <Link to={href} className="block group game-card-hover">
      <div className="rounded-xl overflow-hidden cursor-pointer card-sm">
        <div className="relative w-full pb-[100%]">
          {!loaded && <div className="absolute inset-0 skeleton" />}
          <img src={banner} alt={name} loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`} />
          <div className="play-overlay">
            <div className="play-btn-circle">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="white">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
          {badge && <span className={`badge badge-${badge}`}>{badge}</span>}
        </div>
        <div className="game-name">{name}</div>
      </div>
    </Link>
  );
};

export default GameCard;
